import React, { Fragment } from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#FFFFFF",
        },
      }}
    >
      <Fragment>
        <BrowserRouter>
          <Routes>
            <Route path="/home" element={<Home />}></Route>
            <Route path="/" element={<Home />}></Route>
          </Routes>
        </BrowserRouter>
      </Fragment>
    </ConfigProvider>
  );
}

export default App;
